import React__default from 'react';
import classNames from 'classnames';
import { splitTestNameAndGenesCount } from '../../../../utils/extractGenesCount.esm.js';
import styles from './ReflexTestsStaticList.module.esm.js';

var ReflexTestsStaticItem = function (_a) {
    var _b;
    var isAddon = _a.isAddon, _c = _a.item, code = _c.code, name = _c.name, url = _a.url;
    var nameAndCount = splitTestNameAndGenesCount(name);
    return (React__default.createElement("div", { className: classNames(styles.test, (_b = {}, _b[styles.addOn] = isAddon, _b)), "data-testid": "test-".concat(code) },
        url ? (React__default.createElement("a", { "data-testid": "reflex-test-name".concat(isAddon ? '-addOn' : ''), href: url, onClick: function (e) { return e.stopPropagation(); }, rel: "noopener noreferrer", target: "_blank" }, nameAndCount ? nameAndCount.name : name)) : ((nameAndCount === null || nameAndCount === void 0 ? void 0 : nameAndCount.name) || name),
        nameAndCount && React__default.createElement("span", { className: styles.genesCount }, nameAndCount.genesCount)));
};

export { ReflexTestsStaticItem as default };
//# sourceMappingURL=ReflexTestsStaticItem.esm.js.map
